import { useContext, useState } from "react"
import { useNavigate } from "react-router-dom"
import utility from "src/utils/utility"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { PageWrapper, PageTitle, CustomContainer, FlexRow, Input, AppSpan, GridContainer, AppText } from "src/style"
import { FiSearch } from "react-icons/fi"
import { BsFilter, BsThreeDotsVertical } from "react-icons/bs"
import { Dropdown } from "src/component"
import { MdOutlineCheck, MdOutlineKeyboardArrowDown } from "react-icons/md"
import { Product } from "src/model"
import { sampleProducts } from "src/utils/mock-data"
import { RiCloseFill } from "react-icons/ri"
import './style.scss'


const Products: React.FC = () => {
    const navigate = useNavigate()
    const { setInfoProperty } = useContext(AppInfoContext)
    const [products, setProducts] = useState<Array<Product>|null>(null)
    const [selectedProduct, setSelectedProduct] = useState<Product|null>(null)
    const [sortBy, setSortBy] = useState('Installation')
    const [view, setView] = useState('')

    function handleSortBy (sortBy: string) {
        setSortBy(sortBy)
    }

    async function handleProductAction (product: Product, value: string) {
        if (value === 'view-details') {
            await setInfoProperty('selectedProduct', product)
            navigate(`/partner/product/${product.id}`)
        }
        else if (value === 'edit') {
            await setSelectedProduct(product)
            setView('edit-product')
        }
        else {}
    }


    return (
        <>
            <PageWrapper>
                <PageTitle 
                    color='#101828' textSize='3' fontWeight="500"
                >
                    Products
                </PageTitle>
                <FlexRow 
                    justifyContent="space-between" 
                    gap="2" wrap="wrap" topMargin="2"
                >
                    <FlexRow width="auto" sizeUnit="" gap="1.5">
                        <CustomContainer
                            radius='0.8' borderColor='#D0D5DD'
                            leftPadding='1.5' rightPadding='1.5'
                            shadow='0px 1px 2px rgba(16, 24, 40, 0.05)'
                            className='search-box'
                        >
                            <FlexRow>
                                <FiSearch style={{fontSize: '2rem', color: '#667085'}} />
                                <Input 
                                    height='4' leftPadding='1' 
                                    placeholder='Search' 
                                    //onChange={handleDataSearching} 
                                />
                            </FlexRow>
                        </CustomContainer>
                        <GridContainer 
                            width='10.2' height='4'
                            radius='0.8' borderColor='#D0D5DD'
                           // onClick={canFilter}
                        >
                            <FlexRow width='auto' sizeUnit=''>
                                <BsFilter style={{fontSize: '2rem', color: '#344054', marginRight: '1rem'}} />
                                <AppSpan fontWeight="500" color='#344054' cursor='pointer'>Filters</AppSpan>
                            </FlexRow>
                        </GridContainer>
                    </FlexRow>

                    <Dropdown
                        trigger={
                            <FlexRow 
                                justifyContent="space-between" 
                                width="23.3" height="4" gap="2"
                                radius="0.8" borderColor="#D0D5DD"
                                padding="1.5"
                            >
                                <AppSpan cursor="pointer">{sortBy || 'Sort by'}</AppSpan>
                                <MdOutlineKeyboardArrowDown fill='#ADB5BD' fontSize='1.7rem' />
                            </FlexRow>
                        }
                        options={[
                            {value: 'Name', label: 'Name'},
                            {value: 'Rating', label: 'Rating'},
                            {value: 'Installation', label: 'Installation'}
                        ]}
                        onSelect={(value: string) => handleSortBy(value)}
                        width={18}
                    />
                </FlexRow>

                <CustomContainer topMargin='2'>
                    <div 
                        className="products-container_partner"
                    >
                        {
                            sampleProducts?.map((product: Product, index) => {
                                return (
                                    <CustomContainer
                                        height="19.7"
                                        radius="0.8" borderColor="#EAECF0"
                                        padding='2.4'
                                        key={index}
                                    >
                                        <FlexRow justifyContent="space-between" gap="2">
                                            <FlexRow width="auto" sizeUnit="" gap="0.7">
                                                <CustomContainer width='4.8' height='4.8' overflow="hidden">
                                                    <img 
                                                        src={product.logoUrl} 
                                                        className='img-covered' 
                                                        style={{objectFit: 'contain'}}  
                                                    />
                                                </CustomContainer>
                                                <AppText 
                                                    color='#101828' fontWeight="500" textSize='1.6'
                                                >
                                                    {product.name}
                                                </AppText>
                                            </FlexRow>
                                            <Dropdown 
                                                trigger={<BsThreeDotsVertical fontSize='1.6rem' color='#3A3A3A' />}
                                                options={[
                                                    {value: 'view-details', label: 'View product details'},
                                                    {value: 'edit', label: 'Edit product details'},
                                                    {value: 'view-api', label: 'View API calls'},
                                                ].filter(Boolean)}
                                                onSelect={(value: string) => handleProductAction(product, value)}
                                            />
                                        </FlexRow>
                                        <FlexRow justifyContent="space-between" gap="2" topMargin="2">
                                            <FlexRow 
                                                padding="0.5" radius="1.6" gap="0.3"
                                                topPadding="0.2" bottomPadding="0.2"
                                                bgColor={product.isPublished ? '#ECFDF3' : '#F2F4F7'} 
                                                width="auto" sizeUnit=""
                                            >
                                                <AppSpan
                                                    textSize="1.2" fontWeight="500"
                                                    color={product.isPublished ? '#027A48' : '#344054'} 
                                                >
                                                    {product.isPublished ? 'Published' : 'Not-published'}
                                                </AppSpan>
                                                { product.isPublished ?
                                                    <MdOutlineCheck fill='#12B76A' fontSize='1.2rem' />
                                                    : <RiCloseFill fill='#667085' fontSize='1.5rem' />
                                                }
                                            </FlexRow>
                                            <CustomContainer 
                                                width="auto" sizeUnit=""
                                                padding="0.5" radius="1.6"
                                                topPadding="0.2" bottomPadding="0.2"
                                                bgColor={product.status === 'Active' ? '#ECFDF3' : '#F2F4F7'} 
                                            >
                                                <AppText
                                                    textSize="1.2" fontWeight="500"
                                                    color={product.status === 'Active' ? '#027A48' : '#344054'} 
                                                >
                                                    {product.status}
                                                </AppText>
                                            </CustomContainer>
                                        </FlexRow>
                                        <AppText 
                                            topMargin='1.5' cursor="pointer"
                                            style={{whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word'}}
                                            className='truncate-multiline-2'
                                        >
                                            {product.description}
                                        </AppText>
                                    </CustomContainer>
                                )
                            })
                        }
                    </div>
                </CustomContainer>
            </PageWrapper>
        </>
    )
}

export default utility.routeData('products', 'Products', <Products/>)